import type { Hotel_HotelInfoSettingsPageQuery } from "@/lib/gql/__generated__/graphql";

import { useCreateHotelInfoFormModel } from "../use-create-form-model";
import { useUpdateHotelSettingsHotelInfoDefault } from "../use-update/use-update";

type Props = {
	data: Hotel_HotelInfoSettingsPageQuery;
};

export const useInitialized = ({ data }: Props) => {
	const {
		viewModel,
		resetViewModel,
		logoMethods,
		keyVisualMethods,
		hotelSettingsHotelInfoFormModelMethods,
		addressMethods,
		geoLocationMethods,
		snsMethods,
	} = useCreateHotelInfoFormModel({ serverModel: data });

	const { onUpdateHotelSettingsHotelInfoDefault } = useUpdateHotelSettingsHotelInfoDefault({
		viewModel,
		resetViewModel,
	});

	return {
		viewModel,
		logoMethods,
		keyVisualMethods,
		hotelSettingsHotelInfoFormModelMethods,
		addressMethods,
		geoLocationMethods,
		snsMethods,
		onUpdateHotelSettingsHotelInfoDefault,
	};
};
